import React from 'react';

import PropTypes from 'prop-types';

import { Typography } from 'wanderu-components';

function TextReview(props) {
    const {
        review,
    } = props;

    return (
        <div>
            <Typography
                display="inline"
            >
                {review}
            </Typography>
        </div>
    );
}

TextReview.propTypes = {
    review: PropTypes.string.isRequired,
};

export default TextReview;
